// import React, { useState } from 'react';
// import Carousel from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';

// const Slider = ({ SliderImages }) => {
//   const [activeSlide, setActiveSlide] = useState(0);

//   const CustomPagination = ({ totalDots, activeDotIndex }) => {
//     return (
//       <div className="absolute bottom-3 right-5 py-1 flex flex-row justify-center items-center">
//         {Array.from({ length: totalDots }).map((_, index) => (
//           <div
//             key={index}
//             className={`w-2 h-2 rounded-full mx-1 transition-all duration-300 ${
//               activeDotIndex === index 
//                 ? 'bg-red-500 opacity-100' 
//                 : 'bg-gray-300 opacity-60'
//             }`}
//           />
//         ))}
//       </div>
//     );
//   };

//   const settings = {
//     dots: false,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     autoplay: true,
//     autoplaySpeed: 3000,
//     beforeChange: (current, next) => setActiveSlide(next),
//     lazyLoad: 'ondemand',
//   };

//   const renderItem = (item) => {
//     if (typeof item === 'string' && item.trim() !== '') {
//       return (
//         <div className="relative overflow-hidden flex flex-row">
//           <img
//             src={item}
//             alt="Slider content"
//             className="w-full object-cover"
//             onError={(e) => {
//               console.warn('Error loading image:', e);
//               e.target.style.display = 'none';
//             }}
//           />
//         </div>
//       );
//     }
//     return null;
//   };

//   return (
//     <>
//       {Array.isArray(SliderImages) && SliderImages.some(image => image.trim() !== '') && (
//         <div className="flex-1 ">
//           <div className="mx-2.5 rounded overflow-hidden h-48">
//             <Carousel {...settings}>
//               {SliderImages.map((item, index) => (
//                 <div key={index}>
//                   {renderItem(item)}
//                 </div>
//               ))}
//             </Carousel>
//             <CustomPagination totalDots={SliderImages.length} activeDotIndex={activeSlide} />
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Slider;


import React, { useState } from 'react';
import Carousel from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Slider = ({ SliderImages }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  const CustomPagination = ({ totalDots, activeDotIndex }) => {
    return (
      <div className="absolute bottom-3 left-1/2 transform -translate-x-1/2 py-1 flex flex-row justify-center items-center">
        {Array.from({ length: totalDots }).map((_, index) => (
          <div
            key={index}
            className={`w-2 h-2 rounded-full mx-1 transition-all duration-300 ${
              activeDotIndex === index 
                ? 'bg-red-500 opacity-100' 
                : 'bg-gray-300 opacity-60'
            }`}
          />
        ))}
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    beforeChange: (current, next) => setActiveSlide(next),
    // Ensure slides take full width
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: false,
  };

  const renderItem = (item) => {
    if (typeof item === 'string' && item.trim() !== '') {
      return (
        <div className="w-full overflow-visible">
          <img
            src={item}
            alt="Slider content"
            className="w-full h-48 object-cover" // Changed to object-cover
            onError={(e) => {
              console.warn('Error loading image:', e);
              e.target.style.display = 'none';
            }}
          />
        </div>
      );
    }
    return null;
  };

  return (
    <>
      {Array.isArray(SliderImages) && SliderImages.some(image => image.trim() !== '') && (
        <div className="w-full max-w-4xl mx-auto"> {/* Constrain max width for better control */}
          <div className="w-full rounded-lg overflow-hidden">
            <div className="relative">
              <Carousel {...settings}>
                {SliderImages.map((item, index) => (
                  <div key={index} className="w-full outline-none">
                    {renderItem(item)}
                  </div>
                ))}
              </Carousel>
              <CustomPagination totalDots={SliderImages.length} activeDotIndex={activeSlide} />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Slider;
